import styled from "styled-components";

export const Container = styled.div`
  padding-left: 26px;
  padding-right: 26px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: ${(props) => props.theme.layout.maxWidth};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
